
import React, { useEffect,  useState } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { AudioWaveform, Blocks, ChevronDown, Fan, Info, ChartArea, CalendarClock, Video, MessageCircle, Flag, Pencil, DownloadCloud } from "lucide-react";
import fallback_img from "./img/fallback_img.jpg"

import loading_img from "./img/loadingImg.jpg"

import { useRouteMatch,Switch, Route,Link } from "react-router-dom";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
 

import { useParams } from "react-router-dom";
const PlayerPageCardLessonCard =({playerCard1Object,setCurrentItem,contentItem,progress=20})=>{
   const {url} =useRouteMatch();
    const {courseId} = useParams();
    const {subCourseId} = useParams();
 
          const history = useHistory();
                                   
                        
                              
                                 const {item} = useParams();
                                 const {itemId} = useParams();
                                 const {itemStatus} = useParams();
                            
   const ImageFallFB = ({ itemOuter,boxShadow,src,width,aspectRatio, borderRadius,border,paddingLeft,paddingRight}) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [hasError, setHasError] = useState(false);
  
     
          const [reloadItems, setReloadItems] = useState(true);
         
             useEffect(()=>{
                 setReloadItems(false); setReloadItems(true);
                 
             },[ ])

               
  return (
    <div style={{ position: "relative",boxShadow:boxShadow,
    overflow: "hidden",aspectRatio: aspectRatio,padding:"0px",border:border, 
     borderTopLeftRadius:`${borderRadius?.topLeft?.value}${borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${borderRadius?.topRight?.value}${borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${borderRadius?.bottomLeft?.value}${borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${borderRadius?.bottomRight?.value}${borderRadius?.bottomRight?.resolution}`,
              
    width:`${width}%`}}  className={`Theme1InfoCard1-CardImage-AspectRatioXs${itemOuter?.myKey}`}>
      {!isLoaded && !hasError && (
        <div
         style={
             { 
              borderTopLeftRadius:`${borderRadius?.topLeft?.value}${borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${borderRadius?.topRight?.value}${borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${borderRadius?.bottomLeft?.value}${borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${borderRadius?.bottomRight?.value}${borderRadius?.bottomRight?.resolution}`,
                position: "absolute",
      top: 0,
      left: 0,
      width: `${width}%`,
      aspectRatio: aspectRatio,
      objectFit: "cover",  }}
       className={`Theme1InfoCard1-CardImage-AspectRatioXs${itemOuter?.myKey}`}
        >
          <img
        src={loading_img}
        alt=""
      
       style={
             {
             borderTopLeftRadius:`${borderRadius?.topLeft?.value}${borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${borderRadius?.topRight?.value}${borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${borderRadius?.bottomLeft?.value}${borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${borderRadius?.bottomRight?.value}${borderRadius?.bottomRight?.resolution}`,
              
                position: "absolute",border:border,
      top: 0,
      left: 0,
      width: `${width}%`,padding:"0px",
    
      objectFit: "cover", aspectRatio: aspectRatio,  }}
       className={`Theme1InfoCard1-CardImage-AspectRatioXs${itemOuter?.myKey}`}
      />
        </div>
      )}
      
      <img

      
        src={hasError ? fallback_img : src}
        alt=""
        onLoad={() => setIsLoaded(true)}
        onError={() => setHasError(true)}
       style={
             {
                position: "absolute",
      top: 0,
      left: 0,
      width: `${width}%`,
     
      objectFit: "cover",aspectRatio: aspectRatio  }}
       className={`Theme1InfoCard1-CardImage-AspectRatioXs${itemOuter?.myKey}`}
      />
    
    </div>
  );
};
        const showProgress = typeof progress === 'number' && progress >= 0 && progress <= 100;

      
  const [toggleState , setToggleState] =useState(false)
  const [theme , setTheme] =useState("")
        const [itemArr, setItemArr] = useState([]);
               const [counts, setCounts] = useState({});
               
                       const [itemArrLoading, setItemArrLoading] = useState([{},{},{},{}]);
               
      const [sort, setSort] = useState("ASC");
               const [pageNo, setPageNo] = useState(1);
               const [limit, setLimit] = useState(10);
             const [dropDownVal, setDropDownVal] = useState("Active");
                const [startDate, setStartDate] = useState(null);
          
            const [endDate, setEndDate] = useState(null);
      const [advancedFilters , setAdvancedFilters] =useState(true)
         const [toggleStatePaid , setToggleStatePaid] =useState(null)
         const [toggleStateLifetime , setToggleStateLifetime] =useState(null)
       
       const dispatch = useDispatch();
                const user = useSelector((state)=>state?.user?.user);
                     
                const [snackbarVisible, setSnackbarVisible] = useState(false);
                                 const [snackbarColor, setSnackbarColor] = useState("#958FDA");
                                 const [responseMessage, setResponseMessage] =useState("Something Went Wrong!!!");
                           
                                  
                              const showSnackbar = () => {
                                setSnackbarVisible(true);
                              };
                             
                              const hideSnackbar = () => {
                                setSnackbarVisible(false);
                              };
                        
                        
                                   
                                   
                                
                               const [animate, setAnimate] = useState(false);
                 
                  const [loader , setLoader] =useState({status:true});
         
             
                    const currentToken = useSelector((state)=>state?.user?.user?.currentToken);
                    const userEmail = useSelector((state)=>state?.user?.user?.userData?.userEmail
                   );
                   
                       const userData =useSelector((state)=>state?.user?.user);
                      const AppToken = useSelector((state)=>state?.user?.user?.appToken);
                      const appId = useSelector((state)=>state?.user?.user?.appId);
                    
                              
    return(<div style={{margin:"5px",background:`${playerCard1Object?.lessonCard?.bgColor?.color}`,
border:` ${playerCard1Object?.lessonCard?.border?.borderWidth?.value+playerCard1Object?.lessonCard?.border?.borderWidth?.resolution} ${playerCard1Object?.lessonCard?.border?.borderType}  ${playerCard1Object?.lessonCard?.border?.borderColor?.color}`,
 borderTopLeftRadius:`${playerCard1Object?.lessonCard?.borderRadius?.topLeft?.value}${playerCard1Object?.lessonCard?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${playerCard1Object?.lessonCard?.borderRadius?.topRight?.value}${playerCard1Object?.lessonCard?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${playerCard1Object?.lessonCard?.borderRadius?.bottomLeft?.value}${playerCard1Object?.lessonCard?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${playerCard1Object?.lessonCard?.borderRadius?.bottomRight?.value}${playerCard1Object?.lessonCard?.borderRadius?.bottomRight?.resolution}`,
              marginBottom:"2px"}}> 
              {contentItem?.postType=="Video"?
    <div className="sidebarCardChapter" >
   
   
 <div className="sidebarLessonCardOuter" >
<div className="sidebarlessonCard"  onClick={()=>{setCurrentItem(contentItem)}}>
  {playerCard1Object?.lessonCard?.lessonCardTheme=="T1"?
<div className="sidebarlessonInnerSectionThemeTwo"  >
    <div className="">
    <div className="sidebarCardLessonInner">
    <div style={{display:"flex",justifyContent:"left",alignItems:"center",gap:"5px"}}>
    <Video size={26} color={playerCard1Object?.lessonCard?.textColor?.color} />
    <div className="player-cardHeaderFont" style={{fontSize:"16px",fontWeight:"800",margin:"0px",color:`${playerCard1Object?.lessonCard?.textColor?.color}`}}>{contentItem?.postType}</div>
    </div>
    <div style={{background:`${playerCard1Object?.lessonCard?.iconBgColor?.color}`,width:"30px",height:"30px",borderRadius:"50%",
                  display:"flex",justifyContent:"center",alignItems:"center",   alignContent:"center",margin:"10px",cursor:"pointer"}} onClick={()=>{}} ><Info size={22}  color={playerCard1Object?.lessonCard?.iconColor?.color}/></div> 


</div> <ImageFallFB  boxShadow={``}
                  src={playerCard1Object?.lessonCard?.imageThumbnail?.src}
                  border={playerCard1Object?.lessonCard?.imageThumbnail?.border?.borderWidth?.value+playerCard1Object?.lessonCard?.imageThumbnail?.border?.borderWidth?.resolution+" "+playerCard1Object?.lessonCard?.imageThumbnail?.border?.borderType +" "+playerCard1Object?.lessonCard?.imageThumbnail?.border?.borderColor?.color}
                  width={ 100
                  }
                  aspectRatio={playerCard1Object?.lessonCard?.imageThumbnail?.aspectRatio?.value}
                  borderRadius={ playerCard1Object?.lessonCard?.imageThumbnail?.borderRadius
                  }/>
         {showProgress && (
<div className="player-card__progress">
<div className="player-card__progress-row">
<span className="player-cardSubTitleFont"style={{color:`${playerCard1Object?.lessonCard?.textColor?.color}`}}>Progress</span>
<span style={{color:`${playerCard1Object?.lessonCard?.textColor?.color}`}}>{progress}%</span>
</div>
<div className="player-card__progress-bar">
<div className="player-card__progress-fill" style={{ width: `${progress}%` }} />
</div>
</div>
)}           
</div>  
 <div className="sidebarlessonTitleSection" ><div style={{width:"100%"}}>
    
   <h3 className="player-cardTitleFont"  style={{margin:"0px",paddingTop:"0px",marginTop:"-5px",color:`${playerCard1Object?.lessonCard?.textColor?.color}`}}> {contentItem?.Name}</h3>
   <p className="playerSidebarEllipsis player-cardSubTitleFont"style={{margin:"0px",paddingTop:"0px",fontSize:"11px",color:`${playerCard1Object?.lessonCard?.textColor?.color}`}}> </p>
   </div>
</div>
</div>:playerCard1Object?.lessonCard?.lessonCardTheme=="T2"?<div className="sidebarlessonInnerSection" >
    <div className="sidebarlessoImage">
   
  <ImageFallFB  boxShadow={``}
                  src={playerCard1Object?.lessonCard?.imageThumbnail?.src}
                  border={playerCard1Object?.lessonCard?.imageThumbnail?.border?.borderWidth?.value+playerCard1Object?.lessonCard?.imageThumbnail?.border?.borderWidth?.resolution+" "+playerCard1Object?.lessonCard?.imageThumbnail?.border?.borderType +" "+playerCard1Object?.lessonCard?.imageThumbnail?.border?.borderColor?.color}
                  width={ 100
                  }
                  aspectRatio={playerCard1Object?.lessonCard?.imageThumbnail?.aspectRatio?.value}
                  borderRadius={ playerCard1Object?.lessonCard?.imageThumbnail?.borderRadius
                  }/>
         {showProgress && (
<div className="player-card__progress">
<div className="player-card__progress-row">
<span className="player-cardSubTitleFont"style={{color:`${playerCard1Object?.lessonCard?.textColor?.color}`}}>Progress</span>
<span style={{color:`${playerCard1Object?.lessonCard?.textColor?.color}`}}>{progress}%</span>
</div>
<div className="player-card__progress-bar">
<div className="player-card__progress-fill" style={{ width: `${progress}%` }} />
</div>
</div>
)}           
</div>  
 <div className="sidebarlessonTitleSection" ><div style={{width:"100%"}}>
     <div className="sidebarCardLessonInner">
    <div style={{display:"flex",justifyContent:"left",alignItems:"center",gap:"5px"}}>
    <Video size={26} color={playerCard1Object?.lessonCard?.textColor?.color} />
    <div className="player-cardHeaderFont"  style={{fontSize:"16px",fontWeight:"800",margin:"0px",color:`${playerCard1Object?.lessonCard?.textColor?.color}`}}>{contentItem?.postType}</div>
    </div>
    <div style={{background:`${playerCard1Object?.lessonCard?.iconBgColor?.color}`,width:"30px",height:"30px",borderRadius:"50%",
                  display:"flex",justifyContent:"center",alignItems:"center",   alignContent:"center",margin:"10px",cursor:"pointer"}} onClick={()=>{}} ><Info size={22}  color={playerCard1Object?.lessonCard?.iconColor?.color}/></div> 


</div>
   <h3 className="player-cardTitleFont " style={{margin:"0px",paddingTop:"0px",marginTop:"-5px",color:`${playerCard1Object?.lessonCard?.textColor?.color}`}}> {contentItem?.Name}</h3>
   <p className="playerSidebarEllipsis player-cardSubTitleFont"style={{margin:"0px",paddingTop:"0px",fontSize:"11px",color:`${playerCard1Object?.lessonCard?.textColor?.color}`}}></p>
   </div>
</div>
</div>:""}

</div>

<div >
  
 
     <div className="sidebarlessonInnerSection" style={{position:"relative",display:"flex",justifyContent:"space-between",padding:"10px",
     borderRadius:"10px",marginTop:"10px",width:"95%",marginBottom:"10px",
                      background:`${playerCard1Object?.lessonCard?.toggeleCardBgColor?.color}`}}>
              <div className="player-cardSubTitleFont">{playerCard1Object?.lessonCard?.title2}</div>
 
        <span  className=""  style={{marginTop:"-8px"}}>
       
        <label   className="player-switchmutesmall "> 
 <input id="togglemute" checked={toggleState} onChange={e=>setToggleState(e.target.checked)}   type="checkbox"  
    /> 
   
  <span className="player-cardlfmutesmall round"></span>
</label>
    
    </span>
  </div>
      
</div>
    </div>

   </div>:
   contentItem?.postType=="Quiz"?
    <div className="sidebarCardChapter">
   
   
 <div className="sidebarLessonCardOuter" >
<div onClick={()=>{setCurrentItem(contentItem);history.push(`/player/course/${courseId}/subcourse/${subCourseId}/Quiz/${contentItem?.contentID}/${contentItem?.MockTestToken}`)}}>
  <div  className="sidebarlessonCard">
  {playerCard1Object?.lessonCard?.lessonCardTheme=="T1"?
<div className="sidebarlessonInnerSectionThemeTwo"  >
    <div className="">
    <div className="sidebarCardLessonInner">
    <div style={{display:"flex",justifyContent:"left",alignItems:"center",gap:"5px"}}>
    <CalendarClock size={26} color={playerCard1Object?.lessonCard?.textColor?.color} />
    <div className="player-cardHeaderFont" style={{fontSize:"16px",fontWeight:"800",margin:"0px",color:`${playerCard1Object?.lessonCard?.textColor?.color}`}}>{contentItem?.postType}</div>
    </div>
    <div style={{background:`${playerCard1Object?.lessonCard?.iconBgColor?.color}`,width:"30px",height:"30px",borderRadius:"50%",
                  display:"flex",justifyContent:"center",alignItems:"center",   alignContent:"center",margin:"10px",cursor:"pointer"}} onClick={()=>{}} ><Info size={22}  color={playerCard1Object?.lessonCard?.iconColor?.color}/></div> 


</div>   <ChartArea size={60} strokeWidth={1} color={playerCard1Object?.lessonCard?.textColor?.color}     />              
</div>  
 <div className="sidebarlessonTitleSection" ><div style={{width:"100%"}}>
    
    </div>
</div>
</div>:playerCard1Object?.lessonCard?.lessonCardTheme=="T2"?<div className="sidebarlessonInnerSection" >
    <div className="sidebarlessoImage">
       <div style={{display:"flex",justifyContent:"left",alignItems:"center",gap:"5px"}}>
    <CalendarClock size={26} color={playerCard1Object?.lessonCard?.textColor?.color} />
    <div className="player-cardHeaderFont"  style={{fontSize:"16px",fontWeight:"800",margin:"0px",color:`${playerCard1Object?.lessonCard?.textColor?.color}`}}>{contentItem?.postType}</div>
    </div></div>  
 <div className="sidebarlessonTitleSection" ><div style={{width:"100%"}}>
     <div className="sidebarCardLessonInner">
   <div></div>
    <div style={{background:`${playerCard1Object?.lessonCard?.iconBgColor?.color}`,width:"30px",height:"30px",borderRadius:"50%",
                  display:"flex",justifyContent:"center",alignItems:"center",   alignContent:"center",margin:"10px",cursor:"pointer"}} onClick={()=>{}} ><Info size={22}  color={playerCard1Object?.lessonCard?.iconColor?.color}/></div> 


</div>
      </div>
</div>

</div>:""}

</div>

<div ><h3 className="player-cardTitleFont " style={{margin:"10px",paddingTop:"0px",marginTop:"-5px",color:`${playerCard1Object?.lessonCard?.textColor?.color}`}}>{contentItem?.Name}</h3>

    <div  style={{position:"relative",display:"flex",justifyContent:"space-between",
    padding:"10px",flexWrap:"wrap",
     borderRadius:"10px",marginTop:"10px",marginBottom:"10px",
                      background:`${playerCard1Object?.lessonCard?.toggeleCardBgColor?.color}`}}>
<div  style={{position:"relative",width:"100px",display:"flex",justifyContent:"space-between",padding:"10px",
     borderRadius:"10px",marginTop:"3px",marginBottom:"3px",fontSize:"10px",
                      background:`${playerCard1Object?.lessonCard?.bgColor?.color}`}}>

                        Total Time : {contentItem?.quizData?.overall_test_time} Min
                      </div>
<div style={{position:"relative",width:"100px",display:"flex",justifyContent:"space-between",padding:"10px",
     borderRadius:"10px",marginTop:"3px",marginBottom:"3px",fontSize:"10px",
                      background:`${playerCard1Object?.lessonCard?.bgColor?.color}`}}>
                        Total Questions: {contentItem?.quizData?.total_questions}
                      </div>
                      <div  style={{position:"relative",width:"100px",display:"flex",justifyContent:"space-between",padding:"10px",
     borderRadius:"10px",marginTop:"3px",marginBottom:"3px",fontSize:"10px",
                      background:`${playerCard1Object?.lessonCard?.bgColor?.color}`}}>
                        Total Sections: {contentItem?.quizData?.total_sections}
                      </div>
                      <div  style={{position:"relative",width:"100px",display:"flex",justifyContent:"space-between",padding:"10px",
     borderRadius:"10px",marginTop:"3px",marginBottom:"3px",fontSize:"10px",
                      background:`${playerCard1Object?.lessonCard?.bgColor?.color}`}}>Attempts: {contentItem?.quizData?.total_attempts}/{contentItem?.quizData?.testReAttempts} </div>
                      </div>

                      </div>
     <div className="sidebarlessonInnerSection" style={{position:"relative",display:"flex",justifyContent:"space-between",padding:"10px",alignItems:"center",
     borderRadius:"10px",marginTop:"10px",width:"95%",marginBottom:"10px",
                      background:`${playerCard1Object?.lessonCard?.toggeleCardBgColor?.color}`}}>
              <div className="player-cardSubTitleFont">{playerCard1Object?.lessonCard?.titleQuiz}</div>
 
        <span  className=""  >
       
        <label   className="player-switchmutesmall "> 
 <input id="togglemute" checked={toggleState} onChange={e=>setToggleState(e.target.checked)}   type="checkbox"  
    /> 
   
  <span className="player-cardlfmutesmall round"></span>
</label>
    
    </span>
  </div>
     
</div>
    </div>

   </div>:contentItem?.postType=="Image"?"Image":contentItem?.postType=="Ppt"?"PPT":contentItem?.postType=="Audio"?"Audio":contentItem?.postType=="Pdf"?"Pdf":contentItem?.postType=="Zip"?"Zip":""}{}
    <div style={{display:"flex",padding:"5px",justifyContent:"space-between",gap:"7px",background:`${playerCard1Object?.lessonCardButtons?.bgColor?.color}`,
border:` ${playerCard1Object?.lessonCardButtons?.border?.borderWidth?.value+playerCard1Object?.lessonCardButtons?.border?.borderWidth?.resolution} ${playerCard1Object?.lessonCardButtons?.border?.borderType}  ${playerCard1Object?.lessonCardButtons?.border?.borderColor?.color}`,
 borderTopLeftRadius:`${playerCard1Object?.lessonCardButtons?.borderRadius?.topLeft?.value}${playerCard1Object?.lessonCardButtons?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${playerCard1Object?.lessonCardButtons?.borderRadius?.topRight?.value}${playerCard1Object?.lessonCardButtons?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${playerCard1Object?.lessonCardButtons?.borderRadius?.bottomLeft?.value}${playerCard1Object?.lessonCardButtons?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${playerCard1Object?.lessonCardButtons?.borderRadius?.bottomRight?.value}${playerCard1Object?.lessonCardButtons?.borderRadius?.bottomRight?.resolution}`,
              }}>
    <div style={{display:"flex",justifyContent:"space-between",gap:"7px"}}>
<button className="player-card__cart" style={{padding:"5px 3px"}} 
onClick={() => {}}><MessageCircle size={16} color={playerCard1Object?.lessonCardButtons?.iconColor?.color?playerCard1Object?.lessonCardButtons?.iconColor?.color:"#444444"} />
<span className='player-cardButtonFont' style={{fontSize:"10px"}}>{playerCard1Object?.lessonCardButtons?.title1}</span></button>
<button className="player-card__wishlist" style={{padding:"5px 4px"}} onClick={() => {}}><Flag size={16} color={playerCard1Object?.lessonCardButtons?.iconColor?.color?playerCard1Object?.lessonCardButtons?.iconColor?.color:"#444444"} />
<span className='player-cardButtonFont' style={{fontSize:"10px"}}>{playerCard1Object?.lessonCardButtons?.title2}</span></button>
</div> <div style={{display:"flex",justifyContent:"space-between",gap:"7px"}}><button className="player-card__wishlist" style={{padding:"5px 4px"}} onClick={() => {}}><Pencil size={16} color={playerCard1Object?.lessonCardButtons?.iconColor?.color?playerCard1Object?.lessonCardButtons?.iconColor?.color:"#444444"} />
<span className='player-cardButtonFont' style={{fontSize:"10px"}}>{playerCard1Object?.lessonCardButtons?.title3}</span></button>
<button className="player-card__wishlist" style={{padding:"5px 3px"}} onClick={() => {}}><DownloadCloud size={16} color={playerCard1Object?.lessonCardButtons?.iconColor?.color?playerCard1Object?.lessonCardButtons?.iconColor?.color:"#444444"} />
<span className='player-cardButtonFont' style={{fontSize:"10px"}}> {playerCard1Object?.lessonCardButtons?.title4}</span></button>
</div>
</div> 
    </div>)
}
export default PlayerPageCardLessonCard